module.exports = __webpack_public_path__ + "static/media/black_left_arrow_icon.0cb0b4d4.svg";